import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Upload, CheckCircle, Type, X, Loader2 } from 'lucide-react';
import api from "../../../../api/axios"; // Your custom axios instance

// Use your existing slugify logic
const slugify = (text) =>
  text
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9 ]/g, "")
    .trim()
    .replace(/\s+/g, "-");

const AddCategory = () => {
  const [name, setName] = useState('');
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFile = (file) => {
    if (file && file.type.startsWith('image/')) {
      setImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!image) return alert("Veuillez sélectionner une image");
    
    setLoading(true);

    // Create FormData for file upload
    const formData = new FormData();
    formData.append('name', name);
    formData.append('image', image);
    // Note: The slug is generated on the backend for security, 
    // but the frontend can show it if needed.

    try {
      const response = await api.post('/categories', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.data.success) {
        alert('Catégorie créée avec succès !');
        setName('');
        setImage(null);
        setPreview(null);
      }
    } catch (error) {
      console.error("Erreur d'upload:", error.response?.data || error.message);
      alert("Erreur lors de la création.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} className="max-w-2xl mx-auto p-6">
      <div className="mb-8">
        <h2 className="text-2xl font-black uppercase tracking-tight text-gray-900">Nouvelle Catégorie</h2>
        <p className="text-sm font-bold text-[#8A8A89] mt-1">ELECTRO TITAN Dashboard</p>
      </div>

      <div className="bg-white rounded-[2.5rem] shadow-xl shadow-gray-200/40 border border-gray-100 p-8 md:p-10">
        <form onSubmit={handleSubmit} className="space-y-6">
          
          {/* Category Name */}
          <div className="space-y-2">
            <label className="text-[10px] font-black uppercase tracking-widest text-[#8A8A89] ml-2">Nom de la Catégorie</label>
            <div className="relative">
              <Type className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-300" size={18} />
              <input 
                required
                type="text" 
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Ex: Gros Électroménager"
                className="w-full pl-12 pr-4 py-4 bg-gray-50 border-none rounded-2xl focus:ring-2 focus:ring-[#ffaa00] outline-none font-bold text-sm transition-all"
              />
            </div>
            {name && (
              <p className="text-[10px] text-gray-400 ml-2 italic">URL: /categorie/{slugify(name)}</p>
            )}
          </div>

          {/* Drag & Drop Upload */}
          <div className="space-y-2">
            <label className="text-[10px] font-black uppercase tracking-widest text-[#8A8A89] ml-2">Image (WebP recommandé)</label>
            {!preview ? (
              <div 
                onDragOver={(e) => e.preventDefault()}
                onDrop={(e) => { e.preventDefault(); handleFile(e.dataTransfer.files[0]); }}
                onClick={() => document.getElementById('dropzone-file').click()}
                className="border-2 border-dashed border-gray-200 rounded-[2rem] p-10 flex flex-col items-center justify-center hover:border-[#ffaa00] transition-colors cursor-pointer bg-gray-50/50 group"
              >
                <div className="bg-white p-4 rounded-2xl shadow-sm group-hover:scale-110 transition-transform">
                  <Upload className="text-[#ffaa00]" size={28} />
                </div>
                <p className="mt-4 text-xs font-black text-gray-400 uppercase tracking-tighter">Glissez-déposez ou cliquez ici</p>
                <input id="dropzone-file" type="file" className="hidden" accept="image/*" onChange={(e) => handleFile(e.target.files[0])} />
              </div>
            ) : (
              <div className="relative rounded-[2rem] overflow-hidden group shadow-inner">
                <img src={preview} alt="Preview" className="w-full h-56 object-cover" />
                <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                   <button 
                    type="button"
                    onClick={() => { setPreview(null); setImage(null); }}
                    className="p-3 bg-red-500 text-white rounded-full shadow-xl hover:scale-110 transition-transform"
                  >
                    <X size={20} />
                  </button>
                </div>
              </div>
            )}
          </div>

          <button 
            disabled={loading}
            type="submit"
            className="w-full py-5 bg-[#ffaa00] text-white rounded-2xl font-black uppercase tracking-[0.2em] text-xs shadow-lg shadow-orange-100 hover:bg-black transition-all flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? <Loader2 className="animate-spin" /> : 'Créer la Catégorie'}
            {!loading && <CheckCircle size={18} />}
          </button>
        </form>
      </div>
    </motion.div>
  );
};

export default AddCategory;